// components/DeliveryAddressFactory.tsx

import React from 'react';
import DeliveryAddressGB from './DeliveryAddressGB';
import DeliveryAddressUS from './DeliveryAddressUS';
import { getRemoteEnv } from '../../../config/remoteEnv';

type Address = {
  line1: string;
  line2: string;
  city: string;
  country: string;
  postcode: string;
  latitude?: number;   // NEW
  longitude?: number;  // NEW
  matchedAddress?: string; // NEW - to show what Nominatim returned
} | null;

type Props = {
  address: Address;
  setAddress: (address: Address) => void;
};

const DeliveryAddressFactory: React.FC<Props> = (props) => {
  const countryCode = getRemoteEnv().countryCode || 'GB';

  switch (countryCode) {
    case 'US':
      return <DeliveryAddressUS {...props} />;
    case 'GB':
    default:
      return <DeliveryAddressGB {...props} />;
  }
};

export default DeliveryAddressFactory;